<div class="ui-g-12 no-padding external-report-container">
	<div #ElementReferenceContainer>
	</div>
</div>